
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import pc from './pc/inicio.vue';
    import movil from './movil/inicio.vue';

    @Component( {
        name: "Componente",
        props: {},
        components: { pc, movil }
    } )
    export default class Componente extends Vue
    {
        created()
        {
        }


    }
